/* House of Vyasa: small behaviours on top of Dawn. No dependencies.
   - dedication live preview (+ second copy for the pack variant)
   - surprise-gift toggle
   - add-ons added alongside the book; Buy now that skips the cart
   - sticky mobile bar
   - countdown to real deadlines
   - cart drawer pack upsell and second dedication
   - spin-wheel offer popup with a stored, non-resetting expiry
   - see-inside slider arrows, autoplay of the first product video */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  var routesOr = function (key, fallback) { return (window.routes && window.routes[key]) || fallback; };

  function postJSON(url, body) {
    var adding = /\/cart\/add/.test(url);
    var items = body.items || [];
    var data = { source: 'custom_cart', action: adding ? 'add' : body.quantity === 0 ? 'remove' : 'update', quantity: adding ? (Number(items[0] && items[0].quantity) || 1) : Number(body.quantity) };
    if (adding && items[0]) data.variant_id = String(items[0].id);
    var track = function (name, reason) { if (window.HovAnalytics) window.HovAnalytics.capture(name, Object.assign({}, data, reason ? { reason: reason } : {})); };
    track(adding ? 'hov_add_to_cart_started' : 'hov_cart_change_started');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (result) {
        if (!r.ok || result.status) throw new Error(result.description || result.message || 'Something went wrong');
        if (adding) {
          var first = result.items && result.items[0];
          data.product_id = result.product_id || (first && first.product_id);
          data.item_count = items.reduce(function (sum, item) { return sum + (Number(item.quantity) || 1); }, 0);
        }
        track(adding ? 'hov_added_to_cart' : 'hov_cart_changed');
        return result;
      });
    }).catch(function (error) {
      track(adding ? 'hov_add_to_cart_failed' : 'hov_cart_change_failed', 'request_failed');
      throw error;
    });
  }

  /* ---------- dedication preview ---------- */
  function initDedication(root) {
    var plate = $('[data-hov-plate]', root);
    var preview = $('.hov-ded-preview', root);
    if (preview && window.matchMedia('(min-width: 750px)').matches) preview.open = true;
    var fold = $('[data-hov-ded-fold]', root);
    var active = '1';
    // A tab-scoped draft survives refreshes without retaining gift messages indefinitely.
    var draftKey = 'hov-dedication-' + root.dataset.product;
    try {
      var saved = JSON.parse(sessionStorage.getItem(draftKey) || 'null');
      if (saved && Date.now() - saved.at < 86400000) {
        $$('[data-hov-field]', root).forEach(function (el) { if (saved.fields[el.name] !== undefined) el.value = saved.fields[el.name]; });
      }
    } catch (e) {}
    if (fold && (window.matchMedia('(min-width: 750px)').matches || $$('[data-hov-field]', root).some(function (el) { return el.value.trim(); }))) fold.open = true;
    if (fold) fold.addEventListener('toggle', function () {
      if (fold.open && window.HovAnalytics) window.HovAnalytics.capture('hov_dedication_opened', { where: 'product' });
    });
    function saveDraft() {
      var fields = {};
      $$('[data-hov-field]', root).forEach(function (el) { fields[el.name] = el.value; });
      try { sessionStorage.setItem(draftKey, JSON.stringify({ at: Date.now(), fields: fields })); } catch (e) {}
    }
    root.addEventListener('click', function (e) {
      var choice = e.target.closest('[data-hov-message]');
      if (!choice) return;
      var field = $('[data-hov-group="' + active + '"] [data-hov-field="message"]', root);
      if (!field || field.disabled) field = $('[data-hov-group="1"] [data-hov-field="message"]', root);
      field.value = choice.dataset.hovMessage;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.focus();
    });
    function paint(groupId) {
      if (!plate) return;
      var group = $('[data-hov-group="' + groupId + '"]', root);
      if (!group) return;
      ['for', 'message', 'from'].forEach(function (f) {
        var input = $('[data-hov-field="' + f + '"]', group);
        var out = $('[data-hov-out="' + f + '"]', plate);
        if (!input || !out) return;
        var sampleKey = f === 'for' && groupId === '2' ? 'sampleFor2' : 'sample' + f.charAt(0).toUpperCase() + f.slice(1);
        var val = input.value.trim();
        out.textContent = val || plate.dataset[sampleKey] || '';
        out.dataset.sample = val ? 'false' : 'true';
      });
    }
    $$('[data-hov-group]', root).forEach(function (group) {
      var id = group.dataset.hovGroup;
      group.addEventListener('input', function (e) {
        active = id;
        saveDraft();
        var counter = $('[data-hov-count]', group);
        var msg = $('[data-hov-field="message"]', group);
        if (counter && msg) counter.textContent = msg.value.length + '/160';
        if (e.target.matches('[data-hov-field]')) paint(id);
      });
      group.addEventListener('focusin', function () { if (active !== id) { active = id; paint(id); } });
    });
    root._hovPaint = function () { paint(active); };
    $$('[data-hov-group]', root).forEach(function (group) {
      var msg = $('[data-hov-field="message"]', group), count = $('[data-hov-count]', group);
      if (msg && count) count.textContent = msg.value.length + '/160';
    });
    paint('1');
  }

  function togglePackFields(sectionId, variant) {
    $$('[data-hov-ded][data-section="' + sectionId + '"]').forEach(function (root) {
      var box = $('[data-hov-copy2]', root);
      if (!box) return;
      var packTitle = (box.dataset.packTitle || '').trim();
      var on = !!(variant && packTitle && String(variant.title).trim().toLowerCase() === packTitle);
      box.hidden = !on;
      $$('input, textarea', box).forEach(function (el) { el.disabled = !on; });
      if (!on && root._hovPaint) {
        var first = $('[data-hov-group="1"] [data-hov-field="for"]', root);
        if (first) first.dispatchEvent(new Event('focusin', { bubbles: true }));
      }
    });
  }

  /* ---------- surprise gift ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-hov-gift]')) {
      var wrap = t.closest('[data-hov-gift-wrap]');
      var note = wrap && $('[data-hov-gift-note]', wrap);
      if (note) {
        note.hidden = !t.checked;
        $$('textarea', note).forEach(function (el) { el.disabled = !t.checked; });
      }
    }
  });

  /* ---------- phones: steady viewport height, scroll lock that iOS respects ---------- */
  // In the Instagram and Facebook in-app browsers every vh unit follows the toolbar, so media
  // sized by 100vh grows and shrinks while scrolling. Measure once; re-measure on width changes only.
  (function () {
    var root = document.documentElement, width = window.innerWidth;
    if (!root || !window.addEventListener) return;
    var set = function () { root.style.setProperty('--hov-vh', window.innerHeight + 'px'); };
    set();
    window.addEventListener('resize', function () { if (window.innerWidth !== width) { width = window.innerWidth; set(); } });
  })();
  // Dawn locks the page behind drawers with overflow: hidden on <body>, which iOS ignores for
  // touch scrolling. On touch screens, pin the body in place while a drawer or modal is open and
  // put the reader back where they were afterwards. This follows the drawers themselves, not
  // Dawn's class: pinning the body scrolls the window to 0, and Dawn's header answers that scroll
  // by clearing overflow-hidden (seen on iOS 26.5, 14 Oct 2026).
  (function () {
    if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches || !('MutationObserver' in window)) return;
    var body = document.body, locked = false, y = 0;
    var OPEN = 'cart-drawer.active, header-drawer details[open], details-modal details[open], modal-dialog[open]';
    var wants = function () { return !!document.querySelector(OPEN) && !(window.Shopify && window.Shopify.designMode); };
    var sync = function () {
      if (wants() === locked) return;
      locked = !locked;
      if (locked) {
        y = window.scrollY;
        body.style.top = -y + 'px';
        body.classList.add('hov-scroll-lock');
      } else {
        body.classList.remove('hov-scroll-lock');
        body.style.top = '';
        var html = document.documentElement, behaviour = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, y);
        html.style.scrollBehavior = behaviour;
      }
    };
    new MutationObserver(sync).observe(body, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] });
  })();

  /* ---------- cart drawer: a scroll bar that stays on screen ---------- */
  // Phones only show a scroll bar while you scroll, so a second line or an open dedication below
  // the fold is easy to miss. While the drawer's list is longer than the drawer, draw our own bar
  // and keep it in step; it can be dragged. Dawn re-renders the drawer's insides on every cart
  // change, so the bar is put back after each render.
  (function () {
    if (!('MutationObserver' in window) || !document.querySelector) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var track, thumb, scroller, queued = false, drag = null;
    function pick() {
      var items = drawer.querySelector('cart-drawer-items');
      var inner = drawer.querySelector('.drawer__inner');
      // Under 650px of height Dawn scrolls the whole drawer instead of the list.
      if (items && items.scrollHeight > items.clientHeight + 1 && getComputedStyle(items).overflowY !== 'visible') return items;
      if (inner && inner.scrollHeight > inner.clientHeight + 1) return inner;
      return null;
    }
    function build(inner) {
      track = document.createElement('div');
      track.className = 'hov-rail__track';
      track.setAttribute('aria-hidden', 'true');
      thumb = document.createElement('div');
      thumb.className = 'hov-rail__thumb';
      track.appendChild(thumb);
      inner.appendChild(track);
      track.addEventListener('pointerdown', function (e) {
        if (!scroller) return;
        e.preventDefault();
        var r = track.getBoundingClientRect(), t = thumb.getBoundingClientRect();
        // A press on the bar's empty part moves the thumb there first.
        var grab = e.target === thumb ? e.clientY - t.top : t.height / 2;
        drag = { grab: grab, top: r.top, span: r.height - t.height };
        track.classList.add('is-dragging');
        if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
        follow(e);
      });
      track.addEventListener('pointermove', function (e) { if (drag) follow(e); });
      var end = function () { drag = null; if (track) track.classList.remove('is-dragging'); };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
    }
    function follow(e) {
      var at = Math.min(Math.max(e.clientY - drag.top - drag.grab, 0), Math.max(drag.span, 1));
      scroller.scrollTop = (at / Math.max(drag.span, 1)) * (scroller.scrollHeight - scroller.clientHeight);
    }
    function draw() {
      queued = false;
      var inner = drawer.querySelector('.drawer__inner');
      if (!inner) return;
      if (!track || !inner.contains(track)) build(inner);
      scroller = pick();
      drawer.classList.toggle('hov-rail', !!scroller);
      if (!scroller) { track.hidden = true; return; }
      var ir = inner.getBoundingClientRect(), sr = scroller.getBoundingClientRect();
      // Absolute inside the drawer; when the drawer itself scrolls, ride along with its scroll.
      var top = (scroller === inner ? inner.scrollTop : sr.top - ir.top) + 8;
      var height = scroller.clientHeight - 16;
      track.hidden = false;
      track.style.top = top + 'px';
      track.style.height = height + 'px';
      var size = Math.max(28, height * scroller.clientHeight / scroller.scrollHeight);
      var room = scroller.scrollHeight - scroller.clientHeight;
      thumb.style.height = size + 'px';
      thumb.style.transform = 'translateY(' + (room > 0 ? (height - size) * scroller.scrollTop / room : 0) + 'px)';
    }
    function queue() { if (!queued) { queued = true; (window.requestAnimationFrame || setTimeout)(draw); } }
    new MutationObserver(function (records) {
      // Our own moves of the thumb are not changes to the cart.
      for (var i = 0; i < records.length; i++) if (!track || !track.contains(records[i].target)) return queue();
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'hidden'] });
    document.addEventListener('scroll', function (e) { if (scroller && e.target === scroller) queue(); }, true);
    document.addEventListener('toggle', function (e) { if (drawer.contains(e.target)) queue(); }, true);
    document.addEventListener('input', function (e) { if (drawer.contains(e.target)) queue(); }, true);
    window.addEventListener('resize', queue);
    drawer.addEventListener('transitionend', queue);
    queue();
  })();

  /* ---------- product photos: the first one alone, the rest after it ---------- */
  // The gallery is a side-by-side strip, so lazy loading fetched all seven photos with the first
  // (about 610 KB on a phone, 16 Oct 2026). The later photos and the zoom view's photos carry
  // their addresses in data-hov-src/srcset (product-thumbnail, product-media). Gallery photos load
  // 1.2s after the first photo arrives, on the first touch of the gallery, or on an edition change,
  // whichever is first; zoom photos load when the zoom view is opened.
  (function () {
    if (!document.querySelector) return;
    function fill(root) {
      $$('img[data-hov-srcset], img[data-hov-src]', root).forEach(function (img) {
        if (img.dataset.hovSrcset) img.srcset = img.dataset.hovSrcset;
        if (img.dataset.hovSrc) img.src = img.dataset.hovSrc;
        img.removeAttribute('data-hov-srcset');
        img.removeAttribute('data-hov-src');
      });
    }
    var awake = false;
    function wake() {
      if (awake) return;
      awake = true;
      $$('media-gallery').forEach(fill);
      // Edition changes add and reorder slides; fill whatever arrives.
      if (window.MutationObserver) $$('media-gallery').forEach(function (g) {
        new MutationObserver(function () { fill(g); }).observe(g, { childList: true, subtree: true });
      });
    }
    var gallery = $('media-gallery');
    if (!gallery) return;
    var first = $('.product__media-item img:not([data-hov-src])', gallery);
    var soon = function () { setTimeout(wake, 1200); };
    if (!first || first.complete) soon();
    else { first.addEventListener('load', soon, { once: true }); first.addEventListener('error', soon, { once: true }); }
    setTimeout(wake, 6000);
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (type) { gallery.addEventListener(type, wake, { passive: true, once: true }); });
    var list = $('.product__media-list', gallery);
    if (list) list.addEventListener('scroll', wake, { passive: true, once: true });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) wake(); }, true);
    // Zoom view: start loading on the press, before the dialog opens.
    ['pointerdown', 'click', 'keydown'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var opener = e.target.closest && e.target.closest('modal-opener[data-modal]');
        var modal = opener && document.querySelector(opener.dataset.modal);
        if (modal) fill(modal);
      }, true);
    });
  })();

  /* ---------- edition switch without the wait ---------- */
  // Dawn asks Shopify for the product section again on every edition tap (about a second). Once
  // the page has settled, fetch the section for each edition and answer Dawn's request from that
  // copy while it is fresh. Only for single-option products, where one value is one request.
  (function () {
    if (!window.fetch || !window.Map || !window.Response || !document.querySelector) return;
    if (navigator.connection && navigator.connection.saveData) return;
    var native = window.fetch.bind(window), cache = new Map(), FRESH = 5 * 60 * 1000;
    function warm() {
      $$('product-info[data-section][data-url]').forEach(function (info) {
        var sets = $$('variant-selects fieldset', info);
        if (sets.length !== 1) return;
        $$('input[data-option-value-id]', sets[0]).forEach(function (input) {
          var url = info.dataset.url + '?section_id=' + info.dataset.section + '&option_values=' + input.dataset.optionValueId;
          if (cache.has(url)) return;
          var got = native(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
          got.catch(function () { cache.delete(url); });
          cache.set(url, { at: Date.now(), text: got });
        });
      });
    }
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var hit = url && cache.get(url);
      if (!hit || Date.now() - hit.at > FRESH) return native(input, init);
      var signal = init && init.signal;
      return new Promise(function (resolve, reject) {
        var abort = function () { reject(new DOMException('Aborted', 'AbortError')); };
        if (signal) { if (signal.aborted) return abort(); signal.addEventListener('abort', abort, { once: true }); }
        hit.text.then(function (text) {
          resolve(new Response(text, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } }));
        }, function () { native(input, init).then(resolve, reject); });
      });
    };
    // After load, or 2.5s in at the latest: a third-party request holds the load event back for
    // over a minute on this store (15 Oct 2026).
    var started = false;
    var later = function () {
      if (started) return;
      started = true;
      if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 1500 }); else setTimeout(warm, 0);
    };
    if (document.readyState === 'complete') later();
    else { window.addEventListener('load', later); setTimeout(later, 2500); }
  })();

  /* ---------- gold buttons: a press you can see ---------- */
  // iOS barely shows :active, and a quick tap releases before the press can be seen. Hold
  // .is-pressed for at least 120ms; the CSS springs the button back when it goes.
  var PRESSABLE = '.hov-btn, .product-form__submit, .cart__checkout-button';
  (function () {
    var held = null, since = 0;
    document.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      var b = e.target.closest && e.target.closest(PRESSABLE);
      if (!b || b.disabled) return;
      held = b; since = Date.now();
      b.classList.add('is-pressed');
    }, { passive: true });
    var release = function () {
      if (!held) return;
      var b = held;
      held = null;
      setTimeout(function () { b.classList.remove('is-pressed'); }, Math.max(0, 120 - (Date.now() - since)));
    };
    document.addEventListener('pointerup', release, { passive: true });
    document.addEventListener('pointercancel', release, { passive: true });
  })();

  /* ---------- a tap that lands while the page is still gliding ---------- */
  // iOS spends the first tap on a moving page stopping it, and sends no click, so the buy
  // button needed two taps while scrolling (15 Oct 2026). When a short, still tap on one of
  // these buttons lands within a moment of a scroll, click it ourselves and drop the native
  // click if one follows.
  (function () {
    var TAPPABLE = '[data-hov-buy], .product-form__submit, .cart__checkout-button, [data-hov-another-go], [data-hov-upsell-go], [data-hov-cded-save]';
    var lastScroll = 0, start = null, ours = 0;
    if (!window.addEventListener) return;
    window.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true, capture: true });
    document.addEventListener('touchstart', function (e) {
      start = null;
      if (e.touches.length !== 1 || Date.now() - lastScroll > 150) return;
      var b = e.target.closest && e.target.closest(TAPPABLE);
      if (b) start = { b: b, x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      var s = start;
      start = null;
      if (!s || s.b.disabled || s.b.getAttribute('aria-disabled') === 'true') return;
      var t = e.changedTouches[0];
      if (Math.abs(t.clientX - s.x) > 10 || Math.abs(t.clientY - s.y) > 10 || Date.now() - s.t > 600) return;
      var under = document.elementFromPoint(t.clientX, t.clientY);
      if (!under || !s.b.contains(under)) return;
      e.preventDefault();
      ours = Date.now();
      s.b.click();
    }, { passive: false });
    document.addEventListener('click', function (e) {
      if (!e.isTrusted || !ours || Date.now() - ours > 700) return;
      if (e.target.closest && e.target.closest(TAPPABLE)) { e.preventDefault(); e.stopImmediatePropagation(); ours = 0; }
    }, true);
  })();

  /* ---------- the drawer opens on the tap ---------- */
  // Shopify takes about a second to answer an add to cart (0.9 to 1.2s measured, 15 Oct 2026).
  // Open the drawer at once with the copy already in it, drawn with the cart's own markup and
  // classes (the #HovCartPending template) so the real cart lands in the same place. Dawn's
  // render replaces it; an error takes it away again.
  var adding = null, viewOwed = false;
  function money(cents, withCode) {
    var n = Math.round(Number(cents) / 100);
    var text = '₹' + (window.Intl ? new Intl.NumberFormat('en-IN').format(n) : String(n));
    return withCode ? text + ' INR' : text;
  }
  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }
  function selectedVariant(info) {
    var tag = $('variant-selects [data-selected-variant]', info) || $('[data-selected-variant]', info);
    try { return tag ? JSON.parse(tag.textContent) : null; } catch (err) { return null; }
  }
  function pendingRow(form) {
    var info = form.closest('product-info') || document;
    var v = selectedVariant(info) || {};
    var h1 = $('h1', info) || $('h1');
    var row = el('tr', 'cart-item hov-pending-row');
    var media = el('td', 'cart-item__media');
    var src = (v.featured_image && v.featured_image.src) || '';
    var pic = $('.product__media img', info);
    if (src) {
      // The URL the cart itself asks for, so the real line's picture is already in the cache.
      var img = el('img', 'cart-item__image');
      img.alt = '';
      img.width = 150;
      img.height = 150;
      img.src = src.replace(/^\/\//, 'https://') + (src.indexOf('?') < 0 ? '?' : '&') + 'width=300';
      media.appendChild(img);
    } else if (pic) {
      var copy = el('img', 'cart-item__image');
      copy.alt = '';
      copy.src = pic.currentSrc || pic.src;
      media.appendChild(copy);
    }
    var details = el('td', 'cart-item__details');
    var title = el('div', 'cart-item__title');
    title.appendChild(el('span', 'cart-item__name h4 break', h1 ? h1.textContent.trim() : ''));
    details.appendChild(title);
    if (v.title && v.title !== 'Default Title') {
      var dl = el('dl');
      var opt = el('div', 'product-option');
      opt.appendChild(el('dt', null, 'Edition:'));
      opt.appendChild(document.createTextNode(' '));
      opt.appendChild(el('dd', null, v.title));
      dl.appendChild(opt);
      details.appendChild(dl);
    }
    var totals = el('td', 'cart-item__totals right');
    var wrap = el('div', 'cart-item__price-wrapper');
    wrap.appendChild(el('span', 'price price--end', v.price != null ? money(v.price) : ''));
    totals.appendChild(wrap);
    var qty = el('td', 'cart-item__quantity');
    var status = el('div', 'hov-pending__status');
    status.setAttribute('role', 'status');
    status.appendChild(el('span', 'hov-comet'));
    status.appendChild(el('span', 'hov-sheen', 'Adding to your cart'));
    qty.appendChild(status);
    row.appendChild(media);
    row.appendChild(details);
    row.appendChild(totals);
    row.appendChild(qty);
    // The dedication they typed, shown the way the cart will show it.
    var cell = el('td', 'hov-cded-cell');
    var box = el('div', 'hov-cded');
    var fields = {};
    $$('[data-hov-field]', info).forEach(function (f) { if (f.value && f.value.trim()) fields[f.getAttribute('name') || ''] = f.value.trim(); });
    var pick = function (key) { for (var k in fields) if (k.indexOf('[' + key + ']') > 0) return fields[k]; return ''; };
    var d = { For: pick('For'), Message: pick('Message'), From: pick('From') };
    if (d.For || d.Message || d.From) {
      box.classList.add('hov-cded--set');
      var show = el('div', 'hov-cded__show');
      show.appendChild(el('p', 'hov-cded__label', 'Dedication on page one'));
      if (d.For) show.appendChild(el('p', 'hov-cded__for', d.For));
      if (d.Message) show.appendChild(el('p', 'hov-cded__msg', d.Message));
      if (d.From) show.appendChild(el('p', 'hov-cded__from', d.From));
      box.appendChild(show);
    } else {
      box.appendChild(el('p', 'hov-cded__none', 'No dedication yet. It is free, printed in gold on page one.'));
    }
    var fake = el('p', 'hov-cded__later', d.For || d.Message || d.From ? 'Edit dedication' : 'Add a dedication');
    box.appendChild(fake);
    cell.appendChild(box);
    row.appendChild(cell);
    return { row: row, price: v.price };
  }
  function stopAdding(close) {
    var drawer = document.querySelector('cart-drawer');
    clearTimeout(adding);
    adding = null;
    if (!drawer) return;
    drawer.classList.remove('hov-adding', 'hov-adding--more');
    $$('.hov-pending, .hov-pending-row, .hov-pending-footer', drawer).forEach(function (node) { node.remove(); });
    $$('.hov-waiting', drawer).forEach(function (node) { node.classList.remove('hov-waiting'); });
    if (close) viewOwed = false;
    if (close && typeof drawer.close === 'function') drawer.close();
  }
  function startAdding(form) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function' || onCartPage() || !(window.Promise && window.fetch)) return;
    var inner = $('.drawer__inner', drawer), header = $('.drawer__header', drawer), tpl = document.getElementById('HovCartPending');
    if (!inner || !header) return;
    stopAdding(false);
    var made = pendingRow(form);
    var tbody = $('cart-drawer-items tbody', drawer);
    var footer = $('.drawer__footer', drawer);
    if (tbody && !drawer.classList.contains('is-empty')) {
      // Copies already in the cart: the new one goes on top, where Shopify will put it.
      tbody.insertBefore(made.row, tbody.firstChild);
      drawer.classList.add('hov-adding--more');
      var items = $('cart-drawer-items', drawer);
      if (items) items.scrollTop = 0;
      if (footer) {
        var value = $('.totals__total-value', footer);
        if (value) value.classList.add('hov-waiting');
      }
    } else if (tpl && tpl.content) {
      var list = tpl.content.firstElementChild.cloneNode(true);
      $('[data-hov-pending-rows]', list).appendChild(made.row);
      header.insertAdjacentElement('afterend', list);
      if (footer) {
        var copy = footer.cloneNode(true);
        copy.classList.add('hov-pending-footer');
        $$('[id]', copy).forEach(function (node) { node.removeAttribute('id'); });
        var total = $('.totals__total-value', copy);
        if (total && made.price != null) total.textContent = money(made.price, true);
        // An empty cart's footer has no reassurance lines and a disabled button; the real one will.
        var sure = tpl.content.querySelector('.hov-cart-confidence'), ctas = $('.cart__ctas', copy);
        if (sure && ctas && !$('.hov-cart-confidence', copy)) ctas.parentNode.insertBefore(sure.cloneNode(true), ctas);
        $$('[disabled]', copy).forEach(function (node) { node.removeAttribute('disabled'); });
        list.insertAdjacentElement('afterend', copy);
      }
      drawer.classList.add('hov-adding');
    } else {
      return;
    }
    $$('.cart__checkout-button', drawer).forEach(function (b) { b.classList.add('hov-waiting'); });
    // Dawn sends Shopify's cart view event as the drawer opens, and not again while it is open.
    // Opened this early it would describe the cart before the add, and the real cart would never
    // be reported. So open quietly here; the view event goes out once the real cart has landed.
    var listEl = $('cart-drawer-items', drawer);
    if (listEl && typeof listEl.dispatchViewEvent === 'function') listEl.dispatchViewEvent = function () {};
    try { drawer.open(); } finally { if (listEl) delete listEl.dispatchViewEvent; }
    viewOwed = !drawer.classList.contains('active');
    clearTimeout(adding);
    adding = setTimeout(function () { stopAdding(true); }, 15000);
  }
  if ('MutationObserver' in window && document.querySelector) {
    var cd = document.querySelector('cart-drawer');
    // Dawn's render replaces the drawer's insides: the placeholder is gone, so is the waiting.
    if (cd) new MutationObserver(function () {
      if (adding && !$('.hov-pending-row', cd)) {
        stopAdding(false);
        // The cart view event the early open held back, now with the real cart in it.
        var real = viewOwed && $('cart-drawer-items', cd);
        viewOwed = false;
        if (real && typeof real.dispatchViewEvent === 'function') real.dispatchViewEvent();
        cd.classList.add('hov-arrived');
        setTimeout(function () { cd.classList.remove('hov-arrived'); }, 700);
      }
    }).observe(cd, { childList: true, subtree: true });
  }

  /* ---------- removing a copy: the bin turns into a spinner, the line dims ---------- */
  document.addEventListener('click', function (e) {
    var bin = e.target.closest && e.target.closest('cart-remove-button');
    if (!bin) return;
    var row = bin.closest('.cart-item');
    if (row) row.classList.add('hov-removing');
    flipSnapshot();
  }, true);
  // Dawn takes its loading class off when the request ends; a line still there was not removed.
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function () {
      $$('.cart-item.hov-removing').forEach(function (row) {
        var list = row.closest('#CartDrawer-CartItems, #main-cart-items');
        if (list && !list.classList.contains('cart__items--disabled')) row.classList.remove('hov-removing');
      });
    }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  /* ---------- after a cart change, lines glide to their new places ---------- */
  // Dawn swaps the drawer's HTML wholesale, so whatever was under a removed or added line jumps.
  // Note where each line and box sat before the change, and after the swap play the move.
  // Lines are known by their copy id, which survives edits; a line's key does not.
  var flipBefore = null;
  function flipKey(node) {
    var ded = node.matches('[data-hov-cded]') ? node : $('[data-hov-cded]', node);
    if (ded) {
      try { var props = lineProperties(ded.dataset.props); if (props._copy) return 'copy:' + props._copy; } catch (err) { /* fall through */ }
      return 'key:' + ded.dataset.key;
    }
    if (node.matches('.hov-another')) return 'another';
    return null;
  }
  function flipNodes() {
    var drawer = document.querySelector('cart-drawer');
    return drawer ? $$('cart-drawer-items .cart-item, cart-drawer-items .hov-another', drawer) : [];
  }
  function flipSnapshot() {
    if (!window.requestAnimationFrame) return;
    flipBefore = {};
    flipNodes().forEach(function (node) { var k = flipKey(node); if (k) flipBefore[k] = node.getBoundingClientRect().top; });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-drawer [data-hov-another-go], cart-drawer [data-hov-upsell-go], cart-drawer [data-hov-cded-save]')) flipSnapshot();
  }, true);
  if ('MutationObserver' in window && document.querySelector) {
    var flipDrawer = document.querySelector('cart-drawer');
    if (flipDrawer) new MutationObserver(function () {
      if (!flipBefore) return;
      var before = flipBefore;
      flipBefore = null;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      flipNodes().forEach(function (node) {
        var k = flipKey(node);
        if (!k) return;
        if (!(k in before)) { node.classList.add('hov-enter'); setTimeout(function () { node.classList.remove('hov-enter'); }, 500); return; }
        var dy = before[k] - node.getBoundingClientRect().top;
        if (Math.abs(dy) < 1) return;
        node.style.transition = 'none';
        node.style.transform = 'translateY(' + dy + 'px)';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            node.style.transition = 'transform 320ms cubic-bezier(.2, .8, .2, 1)';
            node.style.transform = '';
            setTimeout(function () { node.style.transition = ''; }, 360);
          });
        });
      });
    }).observe(flipDrawer, { childList: true, subtree: true });
  }

  /* ---------- one cart line per copy ---------- */
  function newCopyId() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function freshCopyIds(root) { $$('[data-hov-copy-id]', root).forEach(function (el) { el.value = newCopyId(); }); }
  freshCopyIds();
  // Runs before Dawn's product form and our add-on handler read the form (both listen later).
  document.addEventListener('submit', function (e) {
    var formId = e.target.getAttribute && (e.target.getAttribute('id') || '');
    if (formId.indexOf('product-form-') === 0) {
      freshCopyIds();
      startAdding(e.target);
    }
  }, true);

  /* ---------- add to cart with add-ons, and Buy now ---------- */
  function checkedAddons(sectionId) {
    return $$('[data-hov-addons="' + sectionId + '"] input[data-hov-addon]:checked');
  }

  function buildItems(sectionId) {
    var form = document.getElementById('product-form-' + sectionId);
    if (!form) throw new Error('Product form not found');
    var fd = new FormData(form);
    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && String(value).trim() !== '') props[m[1]] = value;
    });
    var id = fd.get('id');
    if (!id) throw new Error(window.variantStrings ? window.variantStrings.unavailable : 'Unavailable');
    var items = [{ id: Number(id), quantity: Number(fd.get('quantity')) || 1, properties: props }];
    checkedAddons(sectionId).forEach(function (el) { items.push({ id: Number(el.value), quantity: 1 }); });
    return items;
  }

  function goToCheckout() {
    // Behave exactly like the cart's own checkout button, so GoKwik (which hooks
    // name="checkout" buttons) takes over; Shopify's checkout otherwise.
    var form = document.createElement('form');
    form.method = 'post';
    form.action = routesOr('cart_url', '/cart');
    form.hidden = true;
    var btn = document.createElement('button');
    btn.type = 'submit';
    btn.name = 'checkout';
    form.appendChild(btn);
    document.body.appendChild(form);
    btn.click();
  }

  function showFormError(sectionId, message) {
    if (adding) stopAdding(true);
    var wrap = $('#MainProduct-' + sectionId + ' .product-form__error-message-wrapper');
    if (wrap) {
      wrap.hidden = false;
      var msg = $('.product-form__error-message', wrap);
      if (msg) msg.textContent = message;
    } else {
      window.alert(message);
    }
  }

  function addItems(sectionId, opts) {
    var items = buildItems(sectionId);
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && !opts.checkout) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return postJSON(routesOr('cart_add_url', '/cart/add') + '.js', body).then(function (res) {
      if (opts.checkout) return goToCheckout();
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        window.location = routesOr('cart_url', '/cart');
      }
    });
  }

  var cartBusy = false;
  function withLoading(btn, work) {
    if (cartBusy) return Promise.resolve();
    cartBusy = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    return Promise.resolve().then(work).finally(function () {
      cartBusy = false;
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    });
  }

  function buyNow(sectionId, btn) {
    var dynamic = $('#MainProduct-' + sectionId + ' .shopify-payment-button__button');
    if (!checkedAddons(sectionId).length && dynamic && !dynamic.disabled) {
      dynamic.click();
      return;
    }
    withLoading(btn, function () { return addItems(sectionId, { checkout: true }); }).catch(function (err) { showFormError(sectionId, err.message); });
  }

  // Add to cart: when add-ons are ticked, add everything in one request.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var formId = form.getAttribute('id') || '';
    if (formId.indexOf('product-form-') !== 0) return;
    var sectionId = formId.replace('product-form-', '');
    if (!checkedAddons(sectionId).length) return; // Dawn handles the plain case
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = $('[name="add"]', form) || $('.product-form__submit', form);
    withLoading(btn, function () { return addItems(sectionId, { checkout: false }); }).catch(function (err) { showFormError(sectionId, err.message); });
  }, true);

  // Dynamic checkout (Buy now) with add-ons ticked: add everything, then check out.
  document.addEventListener('click', function (e) {
    var pay = e.target.closest && e.target.closest('.shopify-payment-button');
    if (!pay) return;
    var info = pay.closest('product-info');
    if (!info) return;
    var sectionId = info.dataset.section;
    if (!checkedAddons(sectionId).length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    withLoading(pay, function () { return addItems(sectionId, { checkout: true }); }).catch(function (err) { showFormError(sectionId, err.message); });
  }, true);

  // Sticky bar
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hov-buy]');
    if (!btn || btn.disabled) return;
    var sectionId = btn.dataset.hovBuy;
    if (btn.dataset.action === 'personalise') {
      var dedication = document.getElementById('HovDed-' + sectionId);
      if (dedication) {
        var folded = $('[data-hov-ded-fold]', dedication);
        if (folded) folded.open = true;
        dedication.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        var firstField = $('[data-hov-field]', dedication);
        if (firstField) firstField.focus({ preventScroll: true });
      }
      return;
    }
    if (btn.dataset.action === 'add_to_cart') {
      var form = document.getElementById('product-form-' + sectionId);
      var submit = form && ($('[name="add"]', form) || $('[type="submit"]', form));
      if (submit) submit.click();
      return;
    }
    buyNow(sectionId, btn);
  });

  function initSticky() {
    var bar = $('[data-hov-sticky]');
    if (!bar) return;
    // iOS 26 Safari paints the strip under its floating toolbar in the colour of the fixed bar it
    // finds at the bottom of the screen, but only when no sticky element sits above the bar.
    // Inside Dawn's sticky product column it found the column, and the page showed through under
    // the bar (seen on iOS 26.5, 14 Oct 2026). A child of <body> is found; the buttons are
    // delegated and look their section up by id, so moving the bar is safe.
    if (!(window.Shopify && window.Shopify.designMode) && bar.parentElement !== document.body) document.body.appendChild(bar);
    var root = document.documentElement;
    var setHeight = function () { if (!bar.hidden && bar.offsetHeight) root.style.setProperty('--hov-sticky-h', bar.offsetHeight + 'px'); };
    if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(bar);
    setHeight();
    // Out of the way while typing: iOS moves fixed bars around the keyboard, Android lifts them onto it.
    document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input, textarea, select, [contenteditable]')) root.classList.add('hov-typing'); });
    document.addEventListener('focusout', function () { root.classList.remove('hov-typing'); });
    document.body.classList.add('hov-has-sticky');
    if (bar.dataset.mobileOnly === 'true') document.body.classList.add('hov-sticky-mobile-only');
    var buy = document.querySelector('.product-form__buttons');
    if (buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { bar.hidden = entries[0].intersectionRatio >= 0.75; }, { threshold: [0, 0.75] }).observe(buy);
    }
  }

  // Keep our variant-dependent bits in step with Dawn's variant picker.
  function onVariantChange(event) {
    var data = event && event.data;
    if (!data) return;
    var sectionId = data.sectionId;
    togglePackFields(sectionId, data.variant);
    ['HovStickyPrice-', 'HovStickyTitle-', 'HovScarcity-'].forEach(function (prefix) {
      var current = document.getElementById(prefix + sectionId);
      var fresh = data.html && data.html.getElementById(prefix + sectionId);
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    });
    $$('[data-hov-buy="' + sectionId + '"]').forEach(function (b) { b.disabled = !(data.variant && data.variant.available); var label = $('span', b); if (label) label.textContent = b.disabled ? 'Sold out' : b.dataset.label; });
  }

  /* ---------- countdown to real deadlines ---------- */
  function parseDeadlines(raw) {
    return String(raw || '').split(/\r?\n/).map(function (line) {
      var parts = line.split('|');
      var when = (parts[0] || '').trim();
      if (!when) return null;
      var iso = when.replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) iso += 'T23:59';
      if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(iso)) iso += '+05:30'; // store time is IST unless an offset is given
      var t = Date.parse(iso);
      return isNaN(t) ? null : { t: t, label: (parts[1] || '').trim() };
    }).filter(Boolean).sort(function (a, b) { return a.t - b.t; });
  }

  function fmtLeft(ms) {
    var m = Math.max(0, Math.floor(ms / 60000));
    var d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    if (d > 0) return d + 'd ' + h + 'h';
    if (h > 0) return h + 'h ' + mm + 'm';
    return mm + 'm';
  }

  function fmtClock(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return p(h) + ':' + p(m) + ':' + p(sec);
  }

  function initCountdowns() {
    var els = $$('[data-hov-countdown]');
    if (!els.length) return;
    function tick() {
      var now = Date.now();
      els.forEach(function (el) {
        var next = parseDeadlines(el.dataset.deadlines).filter(function (d) { return d.t > now; })[0];
        var text = $('[data-hov-countdown-text]', el);
        if (!next || !text) { el.hidden = true; return; }
        text.textContent = '';
        text.appendChild(document.createTextNode((el.dataset.prefix || '') + ' '));
        var strong = document.createElement('strong');
        strong.textContent = fmtLeft(next.t - now);
        text.appendChild(strong);
        if (next.label) text.appendChild(document.createTextNode(' ' + next.label));
        el.hidden = false;
      });
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- cart drawer: pack upsell and second dedication ---------- */
  // Liquid serialises line-item properties as pairs; the Ajax API expects an object.
  function lineProperties(raw) {
    var value = JSON.parse(raw || '{}');
    if (!Array.isArray(value)) return value || {};
    return value.reduce(function (props, pair) { props[pair[0]] = pair[1]; return props; }, {});
  }
  function drawerSections() {
    var drawer = document.querySelector('cart-drawer');
    return drawer ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }
  function renderDrawer(res) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && res.sections) drawer.renderContents(res);
    else window.location.reload();
  }
  function showErr(box, err) {
    var p = $('[data-hov-err]', box);
    if (p) { p.textContent = err.message; p.hidden = false; }
  }

  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-hov-upsell-go]');
    if (go) {
      var box = go.closest('[data-hov-upsell]');
      var props = lineProperties(box.dataset.props);
      // Add first: a sold-out upgrade must never destroy the customer's original gift.
      withLoading(go, function () {
        var addedKey;
        return postJSON(routesOr('cart_add_url', '/cart/add') + '.js', {
          items: [{ id: Number(box.dataset.pack), quantity: 1, properties: props }]
        }).then(function (added) {
          addedKey = added.items[0].key;
          return postJSON(routesOr('cart_change_url', '/cart/change') + '.js', {
            id: box.dataset.key, quantity: 0, sections: drawerSections(), sections_url: window.location.pathname
          }).catch(function (err) {
            return postJSON(routesOr('cart_change_url', '/cart/change') + '.js', { id: addedKey, quantity: 0 })
              .catch(function () { throw new Error('Please review your cart before checkout; the upgrade could not be completed.'); })
              .then(function () { throw err; });
          });
        }).then(function (res) {
          renderDrawer(res);
          if (window.HovAnalytics) window.HovAnalytics.capture('hov_pack_upgraded', { where: 'cart_drawer' });
          // The pack line lists the first copy's dedication; open the editor at the second copy.
          setTimeout(function () {
            var field = $('cart-drawer [data-field="For (copy 2)"]');
            var edit = field && field.closest('details');
            if (edit) { edit.open = true; field.focus({ preventScroll: true }); }
          }, 400);
        });
      }).catch(function (err) { showErr(box, err); });
      return;
    }
    var save = e.target.closest && e.target.closest('[data-hov-copy2-save]');
    if (save) {
      var form = save.closest('[data-hov-copy2-form]');
      var existing = lineProperties(form.dataset.props);
      $$('[data-field]', form).forEach(function (el) {
        if (el.value.trim()) existing[el.dataset.field] = el.value.trim();
        else delete existing[el.dataset.field];
      });
      withLoading(save, function () {
        return postJSON(routesOr('cart_change_url', '/cart/change') + '.js', {
          id: form.dataset.key,
          quantity: Number(form.dataset.qty) || 1,
          properties: existing,
          sections: drawerSections(),
          sections_url: window.location.pathname
        }).then(renderDrawer);
      }).catch(function (err) { showErr(form, err); });
    }
  });

  /* ---------- cart: each copy's dedication, editable in place ---------- */
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }
  function afterCartChange(res) {
    if (onCartPage()) { window.location.reload(); return; }
    renderDrawer(res);
  }
  // Keep Dawn's cart from reading our fields as quantity changes, and Enter from submitting the
  // cart form (which is checkout).
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-hov-cded]')) e.stopPropagation();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.target.tagName !== 'INPUT') return;
    var box = e.target.closest && e.target.closest('[data-hov-cded]');
    if (!box) return;
    e.preventDefault();
    var save = $('[data-hov-cded-save]', box);
    if (save) save.click();
  }, true);
  document.addEventListener('toggle', function (e) {
    var box = e.target.closest && e.target.closest('[data-hov-cded]');
    if (!box || !e.target.open) return;
    if (window.HovAnalytics) window.HovAnalytics.capture('hov_dedication_opened', { where: onCartPage() ? 'cart_page' : 'cart_drawer', had_dedication: box.classList.contains('hov-cded--set') });
    // The checkout button stays on screen, so bring the whole form, Save included, into view.
    var save = $('[data-hov-cded-save]', box);
    if (save && save.scrollIntoView) setTimeout(function () { save.scrollIntoView({ block: 'nearest', behavior: smoothOr() }); }, 60);
  }, true);
  // Cancel: put back what was there and fold the editor away; nothing is sent.
  document.addEventListener('click', function (e) {
    var cancel = e.target.closest && e.target.closest('[data-hov-cded-cancel]');
    if (!cancel) return;
    var box = cancel.closest('[data-hov-cded]');
    $$('[data-field]', box).forEach(function (el) { el.value = el.defaultValue; });
    var err = $('[data-hov-err]', box);
    if (err) err.hidden = true;
    var edit = $('details', box);
    if (edit) edit.open = false;
    if (window.HovAnalytics) window.HovAnalytics.capture('hov_dedication_cancelled', { where: onCartPage() ? 'cart_page' : 'cart_drawer', had_dedication: box.classList.contains('hov-cded--set') });
  });
  document.addEventListener('click', function (e) {
    var save = e.target.closest && e.target.closest('[data-hov-cded-save]');
    if (save) {
      var box = save.closest('[data-hov-cded]');
      var props = lineProperties(box.dataset.props);
      var filled = 0;
      $$('[data-field]', box).forEach(function (el) {
        var val = el.value.trim();
        if (val) { props[el.dataset.field] = val; filled++; } else delete props[el.dataset.field];
      });
      if (!props._copy) props._copy = newCopyId();
      withLoading(save, function () {
        return postJSON(routesOr('cart_change_url', '/cart/change') + '.js', {
          id: box.dataset.key,
          quantity: Number(box.dataset.qty) || 1,
          properties: props,
          sections: onCartPage() ? undefined : drawerSections(),
          sections_url: window.location.pathname
        }).then(function (res) {
          if (window.HovAnalytics) window.HovAnalytics.capture('hov_dedication_saved', { where: onCartPage() ? 'cart_page' : 'cart_drawer', fields: filled, had_dedication: box.classList.contains('hov-cded--set') });
          afterCartChange(res);
        });
      }).catch(function (err) { showErr(box, err); });
      return;
    }
    var another = e.target.closest && e.target.closest('[data-hov-another-go]');
    if (another) {
      var wrap = another.closest('[data-hov-another]');
      withLoading(another, function () {
        return postJSON(routesOr('cart_add_url', '/cart/add') + '.js', {
          items: [{ id: Number(wrap.dataset.variant), quantity: 1, properties: { _copy: newCopyId() } }],
          sections: drawerSections(),
          sections_url: window.location.pathname
        }).then(function (res) {
          afterCartChange(res);
          // Shopify lists the newest line first: open its dedication so they can write it now.
          setTimeout(function () {
            var first = $('cart-drawer [data-hov-cded]:not(.hov-cded--set) details');
            if (first) { first.open = true; var f = $('[data-field]', first); if (f) f.focus({ preventScroll: true }); }
          }, 400);
        });
      }).catch(function (err) { showErr(wrap, err); });
    }
  });

  /* ---------- links within the page: glide there, and open what they point at ---------- */
  function smoothOr() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || a.classList.contains('skip-to-content-link') || a.hasAttribute('data-write-review')) return;
    var url;
    try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
    if (url.pathname !== window.location.pathname || url.hash.length < 2) return;
    var target;
    try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (err) { return; }
    if (!target) return;
    e.preventDefault();
    // A closed section would be a jump to a single line: open it first.
    if (target.tagName === 'DETAILS') target.open = true;
    var fold = $('[data-hov-ded-fold]', target);
    if (fold) fold.open = true;
    target.scrollIntoView({ behavior: smoothOr(), block: 'start' });
    if (window.history && history.replaceState) history.replaceState(history.state, '', url.hash);
  });

  /* ---------- see-inside slider arrows ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hov-slide]');
    if (!b) return;
    var track = document.getElementById(b.getAttribute('aria-controls'));
    if (!track) return;
    var slide = track.firstElementChild;
    var step = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: b.dataset.hovSlide === 'next' ? step : -step, behavior: 'smooth' });
  });

  /* ---------- autoplay the first product video, muted ---------- */
  function autoplayFirstVideo() {
    if (!document.body.dataset.hovAutoplay) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var first = $('.product__media-list .product__media-item');
    var dm = first && $('deferred-media', first);
    if (!dm || typeof dm.loadContent !== 'function') return;
    var tpl = $('template', dm);
    var video = tpl && tpl.content.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    dm.loadContent(false);
    var live = $('video', dm);
    if (live) { live.muted = true; var p = live.play(); if (p && p.catch) p.catch(function () {}); }
  }

  /* ---------- offer popup (spin wheel) ---------- */
  var OFFER = 'hov_offer';          // {code,label,revealedAt,expiresAt}: set once, never re-rolled
  var PENDING = 'hov_offer_pending'; // {code,label}: chosen when the number is submitted
  var DISMISSED = 'hov_offer_dismissed';

  function parseCodes(raw) {
    return String(raw || '').split(/\r?\n/).map(function (line) {
      var p = line.split('|').map(function (s) { return s.trim(); });
      if (!p[0]) return null;
      return { code: p[0], label: p[1] || p[0], weight: Math.max(0, parseFloat(p[2]) || 1) };
    }).filter(Boolean);
  }

  function pickCode(codes) {
    var total = codes.reduce(function (s, c) { return s + c.weight; }, 0);
    var r = Math.random() * total;
    for (var i = 0; i < codes.length; i++) { r -= codes[i].weight; if (r <= 0) return codes[i]; }
    return codes[codes.length - 1];
  }

  function wheelSVG(codes) {
    var segs = codes.slice();
    while (segs.length < 6) segs = segs.concat(codes);
    var n = segs.length, R = 100, c = 110, step = 360 / n;
    var pt = function (a, r) {
      var rad = (a * Math.PI) / 180;
      return (c + r * Math.sin(rad)).toFixed(2) + ' ' + (c - r * Math.cos(rad)).toFixed(2);
    };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
    var out = '<svg viewBox="0 0 220 220" role="img" aria-label="Offer wheel"><circle cx="110" cy="110" r="108" fill="#4A0B0E" stroke="#C9A24A" stroke-width="2"/>';
    segs.forEach(function (s, i) {
      var a0 = i * step, a1 = (i + 1) * step, mid = a0 + step / 2;
      out += '<path d="M110 110 L' + pt(a0, R) + ' A' + R + ' ' + R + ' 0 0 1 ' + pt(a1, R) + ' Z" fill="' + (i % 2 ? '#7E1518' : '#5c0f12') + '" stroke="#C9A24A" stroke-width=".8"/>';
      out += '<text x="110" y="' + (110 - R * 0.62) + '" transform="rotate(' + mid + ' 110 110)" text-anchor="middle" dominant-baseline="middle" fill="#E7CF8E" font-family="Spectral, Georgia, serif" font-size="' + (n > 8 ? 9 : 11) + '">' + esc(s.label) + '</text>';
    });
    out += '<circle cx="110" cy="110" r="16" fill="#C9A24A"/><circle cx="110" cy="110" r="6" fill="#4A0B0E"/></svg>';
    return { html: out, segs: segs, step: step };
  }

  function applyURL(code, redirect) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect || '/');
  }

  function initOffer() {
    var dlg = $('[data-hov-offer]');
    var pill = $('[data-hov-offer-pill]');
    if (!dlg) return;
    var codes = parseCodes(dlg.dataset.codes);
    if (!codes.length) return;
    var hours = Number(dlg.dataset.hours) || 24;
    var redirect = dlg.dataset.applyRedirect || '/';
    var offer = store.get(OFFER);
    var timer;

    function paintPill() {
      if (!pill) return;
      var o = store.get(OFFER);
      if (!o || o.expiresAt <= Date.now()) { pill.hidden = true; return; }
      $('[data-hov-pill-code]', pill).textContent = o.label + ' · ' + o.code;
      $('[data-hov-pill-timer]', pill).textContent = fmtClock(o.expiresAt - Date.now());
      pill.href = applyURL(o.code, redirect);
      pill.hidden = false;
    }

    function paintReveal() {
      var o = store.get(OFFER);
      if (!o) return;
      $('[data-hov-offer-code]', dlg).textContent = o.code;
      $('[data-hov-offer-label]', dlg).textContent = o.label;
      $('[data-hov-offer-timer]', dlg).textContent = fmtClock(o.expiresAt - Date.now());
      $('[data-hov-offer-apply]', dlg).href = applyURL(o.code, redirect);
    }

    function startClock() {
      clearInterval(timer);
      timer = setInterval(function () { paintPill(); if (dlg.open) paintReveal(); }, 1000);
      paintPill();
    }

    function open() {
      if (dlg.open || typeof dlg.showModal !== 'function') return;
      if (!store.get(PENDING) && (store.get(DISMISSED) || document.querySelector('cart-drawer.active') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName))) return;
      dlg.showModal();
    }
    function close() {
      if (dlg.open) dlg.close();
      if (!store.get(OFFER)) store.set(DISMISSED, Date.now());
    }
    $$('[data-hov-offer-close]', dlg).forEach(function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('cancel', function () { if (!store.get(OFFER)) store.set(DISMISSED, Date.now()); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    var wheel = wheelSVG(codes);
    var staticWheel = $('[data-hov-wheel]', dlg);
    if (staticWheel) staticWheel.innerHTML = wheel.html;

    // Already revealed in this browser: never re-roll, only show what is left.
    if (offer) {
      if (offer.expiresAt > Date.now()) startClock();
      return;
    }

    // Choose the code when the number is submitted, before Shopify reloads the page.
    var form = $('#HovOfferForm', dlg) || $('form', dlg);
    if (form) {
      form.addEventListener('submit', function (e) {
        var phone = $('[name="contact[phone]"]', form);
        if (phone && !phone.checkValidity()) { e.preventDefault(); phone.reportValidity(); return; }
        if (!store.get(PENDING)) {
          var c = pickCode(codes);
          store.set(PENDING, { code: c.code, label: c.label });
        }
      });
    }

    var pending = store.get(PENDING);
    var posted = !!$('[data-hov-offer-posted]', dlg);
    var hasErrors = !!$('[data-hov-offer-errors]', dlg);

    if (posted && pending) {
      // Number captured: spin to the chosen code, then store the reveal time once.
      $('[data-hov-offer-step="form"]', dlg).hidden = true;
      var reveal = $('[data-hov-offer-step="reveal"]', dlg);
      reveal.hidden = false;
      var spinBox = $('[data-hov-wheel-spin]', reveal);
      spinBox.innerHTML = wheel.html;
      var svg = $('svg', spinBox);
      var idx = wheel.segs.map(function (s) { return s.code; }).indexOf(pending.code);
      if (idx < 0) idx = 0;
      var target = 360 * 5 + (360 - (idx * wheel.step + wheel.step / 2));
      open();
      var finish = function () {
        var now = Date.now();
        store.set(OFFER, { code: pending.code, label: pending.label, revealedAt: now, expiresAt: now + hours * 3600000 });
        store.del(PENDING);
        fetch(applyURL(pending.code, '/'), { credentials: 'same-origin' }).catch(function () {}); // auto-apply
        paintReveal();
        startClock();
      };
      requestAnimationFrame(function () {
        svg.style.transform = 'rotate(' + target + 'deg)';
        setTimeout(finish, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 4300);
      });
      $('[data-hov-offer-code]', reveal).textContent = '';
      return;
    }

    if (hasErrors) { open(); return; }

    var path = window.location.pathname;
    if (/\/(cart|checkout|account)/.test(path)) return;
    var dismissed = store.get(DISMISSED);
    var reshowMs = (Number(dlg.dataset.reshowDays) || 3) * 86400000;
    if (dismissed && Date.now() - dismissed < reshowMs) return;

    var delay = (Number(dlg.dataset.delay) || 20) * 1000;
    setTimeout(open, delay);
    if (dlg.dataset.exit === 'true' && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(); }
      });
    }
  }

  /* ---------- boot ---------- */
  function boot() {
    $$('[data-hov-ded]').forEach(initDedication);
    initSticky();
    initCountdowns();
    initOffer();
    autoplayFirstVideo();
    // Dawn declares these as top-level script bindings (constants.js, pubsub.js).
    /* global subscribe, PUB_SUB_EVENTS */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
      if (PUB_SUB_EVENTS.cartError) subscribe(PUB_SUB_EVENTS.cartError, function () { if (adding) stopAdding(true); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Home banners: snap track with small dots; pause on hover, touch and hidden tabs. */
(function () {
  document.querySelectorAll('[data-hov-slides]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var n = dots.length;
    if (!track || n < 2) return;
    var ms = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    root.style.setProperty('--hov-slide-ms', ms + 'ms');
    var i = 0, timer = null, reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function mark(k) {
      dots.forEach(function (d, j) {
        d.classList.remove('is-active');
        d.setAttribute('aria-selected', j === k ? 'true' : 'false');
      });
      void root.offsetWidth;
      dots[k].classList.add('is-active');
      root.querySelectorAll('.hov-bn').forEach(function (a, j) { a.classList.toggle('is-current', j === k); });
    }
    function go(k, smooth) {
      i = (k + n) % n;
      var target = track.clientWidth * i;
      track.scrollTo({ left: target, behavior: smooth === false ? 'auto' : 'smooth' });
      // a throttled tab can drop the smooth scroll; land on the slide anyway
      setTimeout(function () { if (Math.abs(track.scrollLeft - target) > 8) track.scrollLeft = target; }, 1100);
      mark(i);
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (root.dataset.autoplay !== 'true' || reduce || document.hidden || root.classList.contains('is-paused')) return;
      timer = setTimeout(function () { go(i + 1); }, ms);
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { root.classList.remove('is-paused'); go(j); }); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var k = Math.round(track.scrollLeft / track.clientWidth);
        if (k !== i) { i = k; mark(i); schedule(); }
      }, 90);
    }, { passive: true });
    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); mark(i); schedule(); });
    track.addEventListener('touchstart', function () { root.classList.add('is-paused'); clearTimeout(timer); }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
    mark(0);
    schedule();
  });
})();

/* Plates: arrow buttons scroll one spread. */
(function () {
  document.querySelectorAll('[data-hov-plates]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    function step(dir) {
      var item = track.querySelector('.hov-plate');
      var w = item ? item.getBoundingClientRect().width + 24 : track.clientWidth * 0.7;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    var p = root.querySelector('[data-prev]'), n = root.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  });
})();

/* ---------- offer chip: counts down to the next real order deadline ---------- */
(function () {
  var chip = document.querySelector('[data-hov-offer]');
  if (!chip) return;
  var KEY = 'hov-offer-closed';
  try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
  var list = String(chip.dataset.deadlines || '').split(/\r?\n/).map(function (line) {
    var parts = line.split('|');
    var iso = (parts[0] || '').trim().replace(' ', 'T');
    if (!iso) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) iso += 'T23:59';
    if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(iso)) iso += '+05:30';
    var t = Date.parse(iso);
    return isNaN(t) ? null : { t: t, label: (parts[1] || '').trim() };
  }).filter(Boolean).sort(function (a, b) { return a.t - b.t; });
  var time = chip.querySelector('[data-hov-offer-time]');
  var forEl = chip.querySelector('[data-hov-offer-for]');
  var p = function (n) { return (n < 10 ? '0' : '') + n; };
  var timer;
  function tick() {
    var now = Date.now();
    var next = list.filter(function (d) { return d.t > now; })[0];
    if (!next) { chip.hidden = true; clearInterval(timer); return; }
    var s = Math.floor((next.t - now) / 1000);
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    time.textContent = (d > 0 ? d + 'd ' : '') + p(h) + ':' + p(m) + ':' + p(sec);
    forEl.textContent = 'left ' + next.label;
    chip.hidden = false;
  }
  tick();
  timer = setInterval(tick, 1000);
  setTimeout(function () { chip.classList.add('is-in'); }, 1200);
  chip.querySelector('[data-hov-offer-close]').addEventListener('click', function () {
    chip.classList.remove('is-in');
    setTimeout(function () { chip.hidden = true; }, 300);
    clearInterval(timer);
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  });
})();

/* ---------- first pages: open the clipped page in full ---------- */
(function () {
  document.querySelectorAll('[data-hov-ex-more]').forEach(function (btn) {
    var page = btn.parentNode.querySelector('[data-hov-ex]');
    if (!page) return;
    btn.addEventListener('click', function () {
      var open = page.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('[data-open]').hidden = open;
      btn.querySelector('[data-close]').hidden = !open;
      if (!open) page.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

/* ---------- turn the pages: a 3D book built from spreads ---------- */
(function () {
  document.querySelectorAll('[data-hov-fb]').forEach(function (root) {
    var book = root.querySelector('[data-fb-book]');
    var pages = Array.prototype.slice.call(book.querySelectorAll('[data-fb-page]'));
    var S = pages.length / 2;
    if (!book || S < 2 || pages.length % 2) return;
    var mk = function (cls) { var d = document.createElement('div'); d.className = cls; return d; };
    var baseL = mk('hov-fb__side hov-fb__side--l'), baseR = mk('hov-fb__side hov-fb__side--r');
    baseL.appendChild(pages[0]);
    baseR.appendChild(pages[pages.length - 1]);
    var leaves = [];
    for (var k = 0; k < S - 1; k++) {
      var leaf = mk('hov-fb__leaf'), front = mk('hov-fb__face hov-fb__face--front'), back = mk('hov-fb__face hov-fb__face--back');
      front.appendChild(pages[2 * k + 1]);
      back.appendChild(pages[2 * k + 2]);
      leaf.appendChild(front); leaf.appendChild(back);
      leaves.push(leaf);
    }
    book.appendChild(baseL); book.appendChild(baseR);
    leaves.forEach(function (l) { book.appendChild(l); });
    root.classList.add('is-ready');

    var count = root.querySelector('[data-fb-count]');
    var phone = window.matchMedia('(max-width: 749px)');
    var s = 0, side = 1; // side: which page a phone shows (0 left, 1 right)
    function layout(animating) {
      leaves.forEach(function (l, k) {
        var flipped = k < s;
        l.classList.toggle('is-flipped', flipped);
        // keep every leaf on its own depth so the browser never draws the wrong page on top
        l.style.transform = flipped ? 'rotateY(-180deg) translateZ(' + -(k + 1) * 0.4 + 'px)' : 'translateZ(' + (S - k) * 0.4 + 'px)';
        if (l !== animating) l.style.zIndex = flipped ? 10 + k : 10 + (S - k);
      });
      book.style.setProperty('--pan', phone.matches && side === 1 ? '-50%' : '0%');
      if (count) count.textContent = s + 1;
      root.classList.toggle('is-first', s === 0 && (!phone.matches || side === 0));
      root.classList.toggle('is-last', s === S - 1 && (!phone.matches || side === 1));
    }
    function turn(dir) {
      if (root.classList.contains('is-gl')) return; // hov-curl.js is turning the pages
      if (phone.matches) {
        if (dir > 0 && side === 0) { side = 1; return layout(); }
        if (dir < 0 && side === 1) { side = 0; return layout(); }
      }
      var next = s + dir;
      if (next < 0 || next > S - 1) return;
      var leaf = leaves[dir > 0 ? s : s - 1];
      leaf.style.zIndex = 200;
      s = next;
      if (phone.matches) side = dir > 0 ? 0 : 1;
      layout(leaf);
      setTimeout(function () { layout(); }, 1150);
    }
    root.querySelector('[data-fb-next]').addEventListener('click', function () { turn(1); });
    root.querySelector('[data-fb-prev]').addEventListener('click', function () { turn(-1); });
    book.addEventListener('click', function (e) {
      var r = book.getBoundingClientRect();
      if (phone.matches) { turn(1); return; }
      turn(e.clientX > r.left + r.width / 2 ? 1 : -1);
    });
    book.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); turn(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); turn(-1); }
    });
    var x0 = null;
    book.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    book.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { e.preventDefault(); turn(dx < 0 ? 1 : -1); }
    });
    phone.addEventListener('change', function () { side = 1; layout(); });
    // hov-curl.js (desktop, WebGL) reads the pages in reading order and moves the spread
    root.hovFb = { pages: pages, spreads: S, get: function () { return s; }, set: function (n) { s = Math.max(0, Math.min(S - 1, n)); side = 1; layout(); } };
    layout();
  });
})();

/* Inline product CTAs return to the dedication rather than the top of the gallery. */
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-hov-return-to-buy]');
  if (!link) return;
  var dedication = document.querySelector('[data-hov-ded]');
  if (!dedication) return;
  event.preventDefault();
  var fold = dedication.querySelector('[data-hov-ded-fold]');
  if (fold) fold.open = true;
  dedication.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  var input = dedication.querySelector('[data-hov-field]');
  if (input) input.focus({ preventScroll: true });
});
